// extracted by mini-css-extract-plugin
export default {"container":"SortingSelect_container__DdU1Q","direction-button":"SortingSelect_direction-button__Cit1D"};